import { ReactComponent as Icon1 } from './SVGFiles/icon1.svg';
import { ReactComponent as Icon2 } from './SVGFiles/icon2.svg';
import { ReactComponent as Icon3 } from './SVGFiles/icon3.svg';
import { ReactComponent as Icon4 } from './SVGFiles/icon4.svg';
import { ReactComponent as Icon5 } from './SVGFiles/icon5.svg';
import { ReactComponent as Icon6 } from './SVGFiles/icon6.svg';
import { ReactComponent as Icon7 } from './SVGFiles/icon7.svg';
import { ReactComponent as Icon8 } from './SVGFiles/icon8.svg';
import { ReactComponent as Icon9 } from './SVGFiles/icon9.svg';
import { ReactComponent as Icon10 } from './SVGFiles/icon10.svg';
import { ReactComponent as Icon11 } from './SVGFiles/icon11.svg';
import { ReactComponent as Icon12 } from './SVGFiles/icon12.svg';
import { ReactComponent as Icon13 } from './SVGFiles/icon13.svg';
import { ReactComponent as Icon14 } from './SVGFiles/icon14.svg';
import { ReactComponent as Icon15 } from './SVGFiles/icon15.svg';
import { ReactComponent as Icon16 } from './SVGFiles/icon16.svg';
import { ReactComponent as Icon17 } from './SVGFiles/icon17.svg';
import { ReactComponent as Icon18 } from './SVGFiles/icon18.svg';
import { ReactComponent as Icon19 } from './SVGFiles/icon19.svg';
import { ReactComponent as Icon20 } from './SVGFiles/icon20.svg';
import { ReactComponent as Icon21 } from './SVGFiles/icon21.svg';
import { ReactComponent as Icon22 } from './SVGFiles/icon22.svg';
import { ReactComponent as Icon23 } from './SVGFiles/icon23.svg';
import { ReactComponent as Icon24 } from './SVGFiles/icon24.svg';
import { ReactComponent as Icon25 } from './SVGFiles/icon25.svg';
import { ReactComponent as Icon26 } from './SVGFiles/icon26.svg';
import { ReactComponent as Icon27 } from './SVGFiles/icon27.svg';
import { ReactComponent as Icon28 } from './SVGFiles/icon28.svg';
import { ReactComponent as Icon29 } from './SVGFiles/icon29.svg';
import { ReactComponent as Icon30 } from './SVGFiles/icon30.svg';
import { ReactComponent as Icon31 } from './SVGFiles/icon31.svg';
import { ReactComponent as Icon32 } from './SVGFiles/icon32.svg';
import { ReactComponent as Icon33 } from './SVGFiles/icon33.svg';
import { ReactComponent as Icon34 } from './SVGFiles/icon34.svg';
import { ReactComponent as Icon35 } from './SVGFiles/icon35.svg';
import { ReactComponent as Icon36 } from './SVGFiles/icon36.svg';
import { ReactComponent as Icon37 } from './SVGFiles/icon37.svg';
import { ReactComponent as Icon38 } from './SVGFiles/icon38.svg';
import { ReactComponent as Icon39 } from './SVGFiles/icon39.svg';
import { ReactComponent as Icon40 } from './SVGFiles/icon40.svg';
import { ReactComponent as Icon41 } from './SVGFiles/icon41.svg';
import { ReactComponent as Icon42 } from './SVGFiles/icon42.svg';
import { ReactComponent as Icon43 } from './SVGFiles/icon43.svg';
import { ReactComponent as Icon44 } from './SVGFiles/icon44.svg';
import { ReactComponent as Icon45 } from './SVGFiles/icon45.svg';
import { ReactComponent as Icon46 } from './SVGFiles/icon46.svg';
import { ReactComponent as Icon47 } from './SVGFiles/icon47.svg';
import { ReactComponent as Icon48 } from './SVGFiles/icon48.svg';
import { ReactComponent as Icon49 } from './SVGFiles/icon49.svg';
import { ReactComponent as Icon50 } from './SVGFiles/icon50.svg';
import { ReactComponent as Icon51 } from './SVGFiles/icon51.svg';
import { ReactComponent as Icon52 } from './SVGFiles/icon52.svg';
import { ReactComponent as Icon53 } from './SVGFiles/icon53.svg';
import { ReactComponent as Icon54 } from './SVGFiles/icon54.svg';
import { ReactComponent as Icon55 } from './SVGFiles/icon55.svg';
import { ReactComponent as Icon56 } from './SVGFiles/icon56.svg';
import { ReactComponent as Icon57 } from './SVGFiles/icon57.svg';
import { ReactComponent as Icon58 } from './SVGFiles/icon58.svg';
import { ReactComponent as Icon59 } from './SVGFiles/icon59.svg';
import { ReactComponent as Icon60 } from './SVGFiles/icon60.svg';
import { ReactComponent as Icon61 } from './SVGFiles/icon61.svg';
import { ReactComponent as Icon62 } from './SVGFiles/icon62.svg';
import { ReactComponent as Icon63 } from './SVGFiles/icon63.svg';
import { ReactComponent as Icon64 } from './SVGFiles/icon64.svg';
import { ReactComponent as Icon65 } from './SVGFiles/icon65.svg';
import { ReactComponent as Icon66 } from './SVGFiles/icon66.svg';
import { ReactComponent as Icon67 } from './SVGFiles/icon67.svg';
import { ReactComponent as Icon68 } from './SVGFiles/icon68.svg';
import { ReactComponent as Icon69 } from './SVGFiles/icon69.svg';
import { ReactComponent as Icon70 } from './SVGFiles/icon70.svg';
import { ReactComponent as Icon71 } from './SVGFiles/icon71.svg';
import { ReactComponent as Icon72 } from './SVGFiles/icon72.svg';
import { ReactComponent as Icon73 } from './SVGFiles/icon73.svg';
import { ReactComponent as Icon74 } from './SVGFiles/icon74.svg';
import { ReactComponent as Icon75 } from './SVGFiles/icon75.svg';
import { ReactComponent as Icon76 } from './SVGFiles/icon76.svg';
import { ReactComponent as Icon77 } from './SVGFiles/icon77.svg';
import { ReactComponent as Icon78 } from './SVGFiles/icon78.svg';
import { ReactComponent as Icon79 } from './SVGFiles/icon79.svg';

const iconTypes = {
  icon1: Icon1,
  icon2: Icon2,
  icon3: Icon3,
  icon4: Icon4,
  icon5: Icon5,
  icon6: Icon6,
  icon7: Icon7,
  icon8: Icon8,
  icon9: Icon9,
  icon10: Icon10,
  icon11: Icon11,
  icon12: Icon12,
  icon13: Icon13,
  icon14: Icon14,
  icon15: Icon15,
  icon16: Icon16,
  icon17: Icon17,
  icon18: Icon18,
  icon19: Icon19,
  icon20: Icon20,
  icon21: Icon21,
  icon22: Icon22,
  icon23: Icon23,
  icon24: Icon24,
  icon25: Icon25,
  icon26: Icon26,
  icon27: Icon27,
  icon28: Icon28,
  icon29: Icon29,
  icon30: Icon30,
  icon31: Icon31,
  icon32: Icon32,
  icon33: Icon33,
  icon34: Icon34,
  icon35: Icon35,
  icon36: Icon36,
  icon37: Icon37,
  icon38: Icon38,
  icon39: Icon39,
  icon40: Icon40,
  icon41: Icon41,
  icon42: Icon42,
  icon43: Icon43,
  icon44: Icon44,
  icon45: Icon45,
  icon46: Icon46,
  icon47: Icon47,
  icon48: Icon48,
  icon49: Icon49,
  icon50: Icon50,
  icon51: Icon51,
  icon52: Icon52,
  icon53: Icon53,
  icon54: Icon54,
  icon55: Icon55,
  icon56: Icon56,
  icon57: Icon57,
  icon58: Icon58,
  icon59: Icon59,
  icon60: Icon60,
  icon61: Icon61,
  icon62: Icon62,
  icon63: Icon63,
  icon64: Icon64,
  icon65: Icon65,
  icon66: Icon66,
  icon67: Icon67,
  icon68: Icon68,
  icon69: Icon69,
  icon70: Icon70,
  icon71: Icon71,
  icon72: Icon72,
  icon73: Icon73,
  icon74: Icon74,
  icon75: Icon75,
  icon76: Icon76,
  icon77: Icon77,
  icon78: Icon78,
  icon79: Icon79
};

export default function IconComponent({ name, size = "100%", color }) {
  const Icon = iconTypes[name];
  return (
    <Icon style={{ width: size, height: size, fill: color }} />
  )
}